const menuItems = [
  { key: 'main', content: 'About Me' },
  { key: 'knowledge', content: 'Knowledge' },
  { key: 'portafolio', content: 'Portafolio' },
  { key: 'experience', content: 'Experience' },
  { key: 'contact', content: 'Contact' },
];

export default menuItems;
